import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// import { DevExtremeModule } from 'devextreme-angular';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

// import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';
// import { HomeComponent } from './modules/pages/home/home/home.component';
// import { MenuComponent } from './modules/pages/home/menu/menu.component';
// import { LegalizacionComponent } from './modules/pages/request/legalizacion/legalizacion.component';
// import { MisTareasComponent } from './modules/home/pages/mis-tareas/mis-tareas.component';
// import { MisProcesosComponent } from './modules/home/pages/mis-procesos/mis-procesos.component';
import { JoyrideModule } from 'ngx-joyride';
// import { DxSelectBoxModule } from "devextreme-angular";
// import { DxDateBoxModule } from 'devextreme-angular';
import { ServicesService } from './services/services.service';
// import { DxChartModule } from 'devextreme-angular';
// import { SoporteComponent } from './modules/pages/support/soporte/soporte.component';
// import { RouterModule, Routes } from '@angular/router';
// import { AnticipoComponent } from './modules/pages/request/anticipo/anticipo.component';
// import { ConceptosCategoriasComponent } from './modules/pages/configuration/conceptos-categorias/conceptos-categorias.component';
// import { GestionComponent } from './modules/pages/configuration/gestion/gestion.component';
// import { ConceptosGastosComponent } from './conceptos-gastos/conceptos-gastos.component';
// import { GestionCuentasComponent } from './gestion-cuentas/gestion-cuentas.component';
// import { NewUsuarioComponent } from './modules/pages/configuration/new-usuario/new-usuario.component';
// import { GestionClientesComponent } from './gestion-clientes/gestion-clientes.component';
// import { UpdateComponent } from './modules/pages/configuration/update/update.component';
// import { GestionCentroCostosComponent } from './modules/pages/configuration/gestion-centro-costos/gestion-centro-costos.component';
// import { ConceptoGastoNewComponent } from './modules/pages/configuration/concepto-gasto-new/concepto-gasto-new.component';
// import { ExtractosCargadosComponent } from './modules/pages/accounting/extractos-cargados/extractos-cargados.component';
// import { TableStatementsComponent } from './modules/pages/accounting/components/table-statements/table-statements.component';
// import { MenuLateralComponent } from './menu-lateral/menu-lateral.component';
// import { TablePrevStatementComponent } from './modules/pages/accounting/components/tablePrevStatement/tablePrevStatement.component';
// import { CargueExtractoBancarioComponent } from './modules/pages/accounting/cargue-extracto-bancario/cargue-extracto-bancario.component';
import { DarseAltaComponent } from './darse-alta/darse-alta.component';
// import { RecaptchaModule } from 'ng-recaptcha';
import { AppComponent } from './app.component';
// import { ErpComponent } from './erp/erp.component';
// import { TableExpensesComponent } from './tableExpenses/tableExpenses.component';
import { RecuperarComponent } from './recuperar/recuperar.component';
// import { TableSubexpensesComponent } from './tableSubexpenses/tableSubexpenses.component';
// import { RevisionPreprocesoComponent } from './modules/pages/request/revision-preproceso/revision-preproceso.component';
// import { RechazarAprobarComponent } from './modules/pages/request/rechazar-aprobar/rechazar-aprobar.component';
// import { TableProcessComponent } from './modules/pages/accounting/components/tableProcess/tableProcess.component';
// import { InformesComponent } from './modules/pages/report/informes/informes.component';
// import { ChartGastoXConceptoComponent } from './modules/pages/report/component/chartGastoXConcepto/chartGastoXConcepto.component';
// import { ChartGastoXFuncionarioComponent } from './modules/pages/report/component/chartGastoXFuncionario/chartGastoXFuncionario.component';
// import { TableTareasColaboradoresComponent } from './modules/pages/report/component/tableTareasColaboradores/tableTareasColaboradores.component';
// import { DetalleCuentaComponent } from './modules/pages/configuration/detalle-cuenta/detalle-cuenta.component';
// import { RevisionGastosComponent } from './modules/pages/request/revision-gastos/revision-gastos.component';
// import { ExtractosAsociacionComponent } from './modules/pages/validation/extractos-asociacion/extractos-asociacion.component';


import { HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppRoutingModule } from './app-routing.module';
// import { ValidationComponent } from './modules/pages/validation/validation/validation.component';

// import {MatSelectModule} from '@angular/material/select';
// import {MatFormFieldModule} from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { ExtractosEdicionComponent } from './modules/pages/accounting/extractos-edicion/extractos-edicion.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { InterceptorService } from './services/interceptor.service';
import { NgxSpinnerModule } from 'ngx-spinner';
// import { TableAnticipoComponent } from './modules/pages/validation/component/table-anticipo/table-anticipo.component';
// import { TableLegalComponent } from './modules/pages/validation/component/table-legal/table-legal.component';
// import { TableInformeTab7Component } from './modules/pages/report/component/table-informe-tab7/table-informe-tab7.component';
// import { TableErp5Component } from './modules/pages/validation/component/table-erp5/table-erp5.component';
// import { TableErp2Component } from './modules/pages/validation/component/table-erp2/table-erp2.component';
// import { TableErp1Component } from './modules/pages/validation/component/table-erp1/table-erp1.component';
// import { TableErp3Component } from './modules/pages/validation/component/table-erp3/table-erp3.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    RecuperarComponent,
    DarseAltaComponent
    // HomeComponent,
    // MenuComponent,
    // ExtractosEdicionComponent,
    // ErpComponent,
    // TableSubexpensesComponent,
    // TableExpensesComponent,
   ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    // DevExtremeModule,
    // DxSelectBoxModule,
    // RecaptchaModule,
    // MatFormFieldModule,
    // MatSelectModule,
    BrowserAnimationsModule,
    NgbModule,
    NgxSpinnerModule,

    JoyrideModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: 'es',
    }),
    NgbModule,

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],


  // exports: [RouterModule],
  providers: [
    ServicesService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true},
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
